/*eslint no-unused-vars: ["error", {"args": "none"}]*/
import i18n from "../i18n";

const state = {
  id: "",
  email: "",
  emailConfirm: "",
  firstname: "",
  lastname: "",
  companyname: "",
  street: "",
  postcode: "",
  city: "",
  country: "",
  becomeAwareOf: null,
  position: null,
  accepted_1: false,
  accepted_3: false,

  //progress level entering data
  level: 1,

  errorMessage: "",
  showError: false,
};

const actions = {
  setID(context, id) {
    context.commit("setID", id);
  },
  setEmail(context, email) {
    context.commit("setEmail", email);
  },
  setEmailConfirm(context, email) {
    context.commit("setEmailConfirm", email);
  },
  setFirstName(context, name) {
    context.commit("setFirstName", name);
  },
  setLastName(context, name) {
    context.commit("setLastName", name);
  },
  setStreet(context, street) {
    context.commit("setStreet", street);
  },
  setPostcode(context, postcode) {
    context.commit("setPostcode", postcode);
  },
  setCity(context, city) {
    context.commit("setCity", city);
  },
  setCountry(context, country) {
    context.commit("setCountry", country);
  },
  setCompanyName(context, name) {
    context.commit("setCompanyName", name);
  },
  setBecomeAwareOf(context, selection) {
    context.commit("setBecomeAwareOf", selection);
  },
  setAccepted_1(context, flag) {
    context.commit("setAccepted_1", flag);
  },
  setAccepted_3(context, flag) {
    context.commit("setAccepted_3", flag);
  },
  incrementLevel(context) {
    context.commit("setLevel", context.state.level + 1);
  },
  decrementLevel(context) {
    context.commit("setLevel", context.state.level - 1);
  },
  resetLevel(context) {
    context.commit("setLevel", 1);
  },
  resetData({ state }) {
    state.id = "";
    state.email = "";
    state.firstname = "";
    state.lastname = "";
    state.companyname = "";
    state.becomeAwareOf = "";
    state.country = "";
    state.position = "";
    (state.emailConfirm = ""),
      (state.street = ""),
      (state.postcode = ""),
      (state.city = ""),
      (state.accepted_1 = false);
    state.accepted_3 = false;
  },
};

const mutations = {
  setID(state, id) {
    state.id = id;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setEmailConfirm(state, email) {
    state.emailConfirm = email;
  },
  setFirstName(state, name) {
    state.firstname = name;
  },
  setLastName(state, name) {
    state.lastname = name;
  },
  setCompanyName(state, name) {
    state.companyname = name;
  },
  setCountry(state, country) {
    state.country = country;
  },
  setBecomeAwareOf(state, selection) {
    state.becomeAwareOf = selection;
  },
  setAccepted_1(state, flag) {
    state.accepted_1 = flag;
  },
  setAccepted_3(state, flag) {
    state.accepted_3 = flag;
  },
  setLevel(state, level) {
    state.level = level;
  },
  setStreet(state, street) {
    state.street = street;
  },
  setPostcode(state, postcode) {
    state.postcode = postcode;
  },
  setCity(state, city) {
    state.city = city;
  },
};

const getters = {
  getID(state) {
    return state.id;
  },
  getEmail(state) {
    return state.email;
  },
  getEmailConfirm(state) {
    return state.emailConfirm;
  },
  getFirstName(state) {
    return state.firstname;
  },
  getLastName(state) {
    return state.lastname;
  },
  getStreet(state) {
    return state.street;
  },
  getPostcode(state) {
    return state.postcode;
  },
  getCity(state) {
    return state.city;
  },
  getCompanyName(state) {
    return state.companyname;
  },
  getcountryItem(state) {
    return state.country;
  },
  getBecomeAwareOf(state) {
    return state.becomeAwareOf;
  },
  getPosition(state) {
    return state.position;
  },
  getAccepted_1(state) {
    return state.accepted_1;
  },
  getAccepted_3(state) {
    return state.accepted_3;
  },
  currentLevel(state) {
    return state.level;
  },
  countryItems() {
    let countries = [];
    for (let index = 0; index <= 30; index++) {
      countries[index] = {
        name: i18n.t(`store.visitor.countryItems.item_${index}`),
        value: index,
      };
    }
    return countries;
  },
};

export const visitors = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
